import moment from "moment";
import { MonetaryAmount } from "../../../app/domain/monetary-amount";

interface RentingCalculations {
  energyEfficiency: number;
  vehiclePrice: number;
  privateUseRatio: number;
  numberOfPayments: number;
  initialPaymentByEmployee: number;
  initialPaymentByCompany: number;
  rentingCostPerPaymentEmployee: number;
  rentingCostPerPaymentCompany: number;
  vatRatioSupportedByEmployee: number;
  serviceStart: string;
}

export const adaptRentingApprovalCalculationsPayload = ({
  privateUsePercentage,
  energeticEfficiency,
  purchasePrice,
  initialAmount,
  rentingQuota,
  rentingCompanyQuota,
  rentingEmployeeQuota,
  date,
  numberOfQuotas,
  whoPaysQuotas,
  vatRatioSupportedByEmployee,
}: {
  privateUsePercentage: number;
  energeticEfficiency: number;
  purchasePrice: number;
  initialAmount: number;
  rentingQuota: number;
  rentingCompanyQuota: number;
  rentingEmployeeQuota: number;
  date: Date;
  numberOfQuotas: number;
  whoPaysQuotas: string;
  vatRatioSupportedByEmployee: number;
}): RentingCalculations => {
  const getAmountInCents = (value) =>
    MonetaryAmount.fromUnitary(value).amountInCents;

  const getInitialPayment = (type) =>
    whoPaysQuotas === type ? getAmountInCents(initialAmount) : 0;

  const getRentingQuota = (type, rentingType) =>
    whoPaysQuotas === type ? 0 : getAmountInCents(rentingType);

  return {
    energyEfficiency: energeticEfficiency / 100,
    vehiclePrice: getAmountInCents(purchasePrice),
    privateUseRatio: privateUsePercentage / 100,
    numberOfPayments: Number(numberOfQuotas),
    initialPaymentByEmployee:
      whoPaysQuotas === "both"
        ? getAmountInCents(initialAmount)
        : getInitialPayment("employee"),
    initialPaymentByCompany: getInitialPayment("company"),
    rentingCostPerPaymentEmployee:
      whoPaysQuotas === "employee"
        ? getAmountInCents(rentingQuota)
        : getRentingQuota("company", rentingEmployeeQuota),
    rentingCostPerPaymentCompany:
      whoPaysQuotas === "company"
        ? getAmountInCents(rentingQuota)
        : getRentingQuota("employee", rentingCompanyQuota),
    vatRatioSupportedByEmployee:
      whoPaysQuotas === "company" ? 0 : vatRatioSupportedByEmployee / 100,
    serviceStart: moment(Math.round(date.getTime())).format("YYYY-MM-DD"),
  };
};
